/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import 'ag-grid-enterprise';
import {ICellRenderer, ICellRendererParams} from "ag-grid-community";

/**
 *
 * @class NumberRenderer
 *
 * @brief helper to render floating point number columns in agGrid
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class NumberRenderer implements ICellRenderer {

  /** agGrid DOM element for display */
  public gui: HTMLElement;

  /** the value being rendered */
  public value: any;

  /** first time creation of the rendered cell. */
  public init(params: ICellRendererParams): void {

    this.gui = document.createElement('div');
    this.gui.innerHTML = `<span style="color: grey;"></span>`;

    /* render! */

    this.refresh(params);
  }

  /** return the currently rendered DOM */
  public getGui(): HTMLElement {

    return this.gui;
  }

  /** update the rendered DOM */
  public refresh(params: ICellRendererParams): boolean {

    if ((params.value === null) || (params.value === '') || (typeof params.value === 'undefined')) {

      this.value = 0;

      this.gui.innerHTML = `<span style="color: grey;"></span>`;

      return ;
    }

    this.value = parseFloat(params.value).toFixed(4);

    if (this.value) {

      this.gui.innerHTML = `<span>${this.value}</span>`;

    } else {

      this.gui.innerHTML = `<span style="color: grey;"></span>`;
    }

    return true;
  }

  /** destructor for rendered DOM */
  public destroy() {

  }

}
